'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { label: 'Home', href: '#hero' },
  { label: 'About', href: '#about' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Services', href: '#events' },
  { label: 'Our Work', href: '#gallery' },
  { label: 'Contact', href: '#contact' }];


  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      id="header"
      className={`fixed left-0 w-full z-40 transition-all duration-500 ${
      scrolled ?
      'bg-[#1e1e1e]/98 border-b border-[#b5973a]/50 shadow-lg shadow-black/50' :
      'bg-[#1e1e1e]/75 border-b border-[#b5973a]/20'}`
      }
      style={{ top: '50px' }}>
      
      <div className="container mx-auto px-4 flex items-center justify-between py-3">
        {/* Logo */}
        <a href="#hero" onClick={(e) => {e.preventDefault();handleNavClick('#hero');}} className="flex items-center gap-3">
          <Image
            src="https://www.gorgisairheat.com/assets/img/logo3.jpg"
            alt="Gorgis Air Conditioning and Heating"
            width={50}
            height={50}
            className="rounded-xl border-2 border-[#b5973a] shadow-lg" />
          
          <span className="font-poppins font-semibold text-white text-sm hidden sm:block leading-tight">
            Gorgis Air Conditioning<br />
            <span className="text-[#b5973a]">&amp; Heating</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) =>
          <a
            key={link.label}
            href={link.href}
            onClick={(e) => {e.preventDefault();handleNavClick(link.href);}}
            className="px-4 py-2 text-white/90 hover:text-[#b5973a] transition-colors duration-300 font-sans text-sm font-medium relative group">
              {link.label}
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-[2px] bg-[#b5973a] group-hover:w-3/4 transition-all duration-300 rounded-full" />
            </a>
          )}
        </nav>

        {/* CTA Button */}
        <div className="flex items-center gap-3">
          <a
            href="#contact"
            onClick={(e) => {e.preventDefault();handleNavClick('#contact');}}
            className="hidden sm:inline-flex items-center bg-[#b5973a] hover:bg-[#d4aa4a] text-white rounded-full px-5 py-2 text-xs font-poppins font-bold uppercase tracking-wider transition-all duration-300 shadow-lg shadow-[#b5973a]/30">
            Get a Free Quote
          </a>
          {/* Mobile toggle */}
          <button
            className="lg:hidden text-white text-2xl p-1"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu">
            
            {mobileOpen ?
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg> :

            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            }
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen &&
      <div className="lg:hidden bg-[#1e1e1e] border-t border-[#b5973a]/30">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) =>
          <a
            key={link.label}
            href={link.href}
            onClick={(e) => {e.preventDefault();handleNavClick(link.href);}}
            className="text-white/90 hover:text-[#b5973a] py-2 px-4 font-sans text-sm font-medium border-b border-[#2d2d2d] transition-colors">
                {link.label}
              </a>
          )}
            <a
            href="#contact"
            onClick={(e) => {e.preventDefault();handleNavClick('#contact');}}
            className="mt-2 text-center bg-[#b5973a] hover:bg-[#d4aa4a] text-white rounded-full px-5 py-2 text-xs font-poppins font-bold uppercase tracking-wider transition-all duration-300">
              Get a Free Quote
            </a>
          </div>
        </div>
      }
    </header>);

}